import { useTranslations } from "adapters/i18n";
import { CauseOfDeathStatusFilter } from "../utils/causeOfDeath.utils";
import { useMemo } from "react";

export function useFilterOptions() {
  const { t } = useTranslations();

  const statusOptions = useMemo(
    () => [
      {
        value: CauseOfDeathStatusFilter.All,
        label: t("common:all-male").toUpperCase(),
      },
      {
        value: CauseOfDeathStatusFilter.Active,
        label: t("common:status.activated-plural").toUpperCase(),
      },
      {
        value: CauseOfDeathStatusFilter.Inactive,
        label: t("common:status.disabled-plural").toUpperCase(),
      },
    ],
    [t]
  );

  return { statusOptions };
}
